"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RegionFormComponent = _interopRequireDefault(require("./RegionFormComponent"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _APLabelWithText = _interopRequireDefault(require("../../../../common/APLabelWithText"));
var _APButton = _interopRequireDefault(require("../../../../common/APButton"));
var _Modal = _interopRequireDefault(require("../../../../common/Modal/Modal"));
require("./RegionSettingsComponent.css");
var _useTranslationsConfig = require("./useTranslationsConfig");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var classes = (0, _cssClassesHelper.getBEMClasses)('region-settings');
var RegionSettingsComponent = function RegionSettingsComponent(_ref) {
  var setUserRegionConfig = _ref.setUserRegionConfig,
    editIsDisabled = _ref.editIsDisabled;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var _useTranslationsConfi = (0, _useTranslationsConfig.useTranslationsConfig)(),
    languageNames = _useTranslationsConfi.languageNames,
    options = _useTranslationsConfi.options;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openModal = _useState2[0],
    setModal = _useState2[1];
  var onSubmit = (0, _react.useCallback)(function (language) {
    setModal(false);
    setUserRegionConfig(language);
  }, [setUserRegionConfig]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("form", {
    className: classes()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Language'),
    text: i18n.resolvedLanguage in languageNames ? languageNames[i18n.resolvedLanguage] : 'English',
    customClass: classes()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('button-container')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: classes(),
    disabled: editIsDisabled || openModal,
    onClick: function onClick() {
      return setModal(true);
    }
  }, t('Edit'))), openModal && /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: openModal,
    title: t('Edit Language'),
    onCancel: function onCancel() {
      return setModal(false);
    },
    close: function close() {
      return setModal(false);
    },
    customClass: classes('ap-modal')
  }, /*#__PURE__*/_react["default"].createElement(_RegionFormComponent["default"], {
    languageOptions: options,
    onSubmit: onSubmit,
    initialValue: i18n.resolvedLanguage
  }))));
};
RegionSettingsComponent.propTypes = {
  setUserRegionConfig: _propTypes["default"].func.isRequired,
  editIsDisabled: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)()(RegionSettingsComponent);